import { Record } from 'immutable';
import { DateTime } from 'luxon';
import { convertRawValues } from '../lib/utils/record_utils';
import { fromISO } from '../lib/utils/datetime_formatters';

export default class LoanRecord extends Record({
  id: null,
  order_id: null,
  created_at: '',
  amount: '',
  amount_refunded: '',
  borrower_fee: '',
  capture_date: '',
  declined_charge_attempts: '',
  installments: '',
  interest_balance: '',
  interest_free_months: '',
  last_auto_payment_try_date: '',
  last_past_due_date: '',
  lifecycle_status: '',
  mambu_loan_id: '',
  merchant_fee: '',
  merchant_fee_amount: '',
  monthly_fee: '',
  monthly_interest: '',
  next_payment_amount: '',
  next_payment_date: '',
  payment_schedule: [],
  payments: [],
  payoff_balance: '',
  principal_balance: '',
  settled_amount: '',
  status: '',
  total_balance: '',
  total_due: '',
  total_monthly_fees: '',
  total_paid: '',
}) {
  constructor(data) {
    data = convertRawValues(data);
    super(data);
  }
  get progress() {
    if (
      ['returned', 'canceled', 'error', 'declined', 'paid'].includes(
        this.status,
      )
    ) {
      return 100;
    }
    return (
      (this.paid_amount /
        (parseFloat(this.amount) + parseFloat(this.total_monthly_fees))) *
      100
    );
  }

  get daysPastDue() {
    let today = DateTime.now();

    let due_date = fromISO(this.last_past_due_date);
    return today.diff(due_date, 'days');
  }

  get isPastDue() {
    return this.lifecycle_status === 'past_due';
  }

  get next_payment_due_amount() {
    return this.next_payment_amount;
  }

  get paid_amount() {
    return (
      parseFloat(this.amount) +
      parseFloat(this.total_monthly_fees) -
      this.total_balance
    );
  }
}
